import axios from "axios";
import { User_Service_URL, Master_Service_URL } from "../Url";
import HashMap from "hashmap";

var map = new HashMap();
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}
export const getAddEmployeeAction = {
  GET_ADD_EMPLOYEE_DETAILS_SUCCESS: "GET_ADD_EMPLOYEE_DETAILS_SUCCESS",
  GET_ADD_EMPLOYEE_DETAILS_ERROR: "GET_ADD_EMPLOYEE_DETAILS_ERROR",
};

export function getAddEmployeeDetail(accessToken) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${User_Service_URL}/getRoleRMAndCET`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getAddEmployeeDetailSuccess(response.data.dtoList));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getAddEmployeeDetailError(error));

          return response;
          // throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function getAddEmployeeDetailError(error) {
  return {
    type: getAddEmployeeAction.GET_ADD_EMPLOYEE_DETAILS_ERROR,
    payload: error,
  };
}

export function getAddEmployeeDetailSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getAddEmployeeAction.GET_ADD_EMPLOYEE_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export const saveAddEmployeeActions = {
  SAVE_ADD_EMPLOYEE_DETAILS_SUCCESS: "SAVE_ADD_EMPLOYEE_DETAILS_SUCCESS",
  SAVE_ADD_EMPLOYEE_DETAILS_ERROR: "SAVE_ADD_EMPLOYEE_DETAILS_ERROR",
};

export function saveAddEmployeeDetails(props) {
  const { access_token, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/save/Employee`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveAddEmployeeSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveAddEmployeeError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveAddEmployeeError(err));
          return err.response;
        }
      });
}

export function saveAddEmployeeError(error) {
  return {
    type: saveAddEmployeeActions.SAVE_ADD_EMPLOYEE_DETAILS_ERROR,
    payload: error,
  };
}

export function saveAddEmployeeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveAddEmployeeActions.SAVE_ADD_EMPLOYEE_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export const getEmployeeDetails = (props) => {
  let { accessToken, userId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      url: `${User_Service_URL}/get/UserMaster/ByUserId?userId=${userId}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);

          return response;
          // throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
};

export const getProductInfo = (props) => {
  let { accessToken } = props;
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Master_Service_URL}/getAllPartnerProductMaster`,
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        if (err.response) {
          return err;
        }
      });
};
